class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    document.querySelectorAll(".js-filter").forEach((item) => {
      item.removeAttribute('open');
    });

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        document.querySelectorAll('.media img[loading="lazy"], .blur-hover img[loading="lazy"]').forEach((img) => {
          img.onload = function (e) {
            img.parentNode.classList.add("loaded")
          }
          if (img.complete) {
            img.parentNode.classList.add('loaded');
          }
        });
        AOS.refresh();
        function findGetParameter(parameterName) {
          var result = null,
            tmp = [];
          location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
              tmp = item.split("=");
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
          return result;
        }

        var color = findGetParameter('filter.v.option.couleur');
        if (color) {
          document.querySelectorAll('[data-variant-color="' + color + '"]').forEach((item) => {
            item.click();
          })
        }

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    document.querySelectorAll('.media img[loading="lazy"], .blur-hover img[loading="lazy"]').forEach((img) => {
      img.onload = function (e) {
        img.parentNode.classList.add("loaded")
      }
      if (img.complete) {
        img.parentNode.classList.add('loaded');
      }
    });
    AOS.init();
    function findGetParameter(parameterName) {
      var result = null,
        tmp = [];
      location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
      return result;
    }

    var color = findGetParameter('filter.v.option.couleur');
    if (color) {
      document.querySelectorAll('[data-variant-color="' + color + '"]').forEach((item) => {
        item.click();
      })
    }

  }

  static renderProductCount(html) {
    //const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const count = document.querySelectorAll('.collection product-card').length;
    const count_label = count > 1 ? " PRODUITS" : " PRODUIT";
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count + count_label;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count + count_label;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));


    this.setFiltersPrice();

    this.setMinAndMaxValues();

  }

  setFiltersPrice() {
    const allPrices = []
    document.querySelectorAll('product-card').forEach((item) => {
      allPrices.push(Number(item.dataset.productPrice))
    })
    var maxValue = Math.max(...allPrices);
    var minValue = Math.min(...allPrices);
    console.log(maxValue + '-' + minValue);
    if (minValue > 5000) {
      document.querySelectorAll('.minus50').forEach((el) => { el.classList.add('hidden') })
    } else {
      document.querySelectorAll('.minus50').forEach((el) => { el.classList.remove('hidden') })
    }
    if (minValue > 10000) {
      document.querySelectorAll('.minus100').forEach((el) => { el.classList.add('hidden') })
    } else {
      document.querySelectorAll('.minus100').forEach((el) => { el.classList.remove('hidden') })
    }
    if (minValue > 15000) {
      document.querySelectorAll('.minus150').forEach((el) => { el.classList.add('hidden') })
    } else {
      document.querySelectorAll('.minus150').forEach((el) => { el.classList.remove('hidden') })
    }
    if (maxValue < 15000) {
      document.querySelectorAll('.over150').forEach((el) => { el.classList.add('hidden') })
    } else {
      document.querySelectorAll('.over150').forEach((el) => { el.classList.remove('hidden') })
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class PriceRadios extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[range-elem]').forEach((item) => {
      item.addEventListener('click', this.updatePriceFilters.bind(this));
    });
  }

  updatePriceFilters(event) {
    var value = event.currentTarget.getAttribute("range-elem").split("-");
    console.log(value);
    document.querySelector('#Filter-Prix-GTE').value = value[0];
    document.querySelector('#Filter-Prix-LTE').value = value[1];
    var event = new Event('change');

    document.querySelector('#Filter-Prix-GTE').dispatchEvent(new Event('input', { bubbles: true }));
    document.querySelector('#Filter-Prix-LTE').dispatchEvent(new Event('input', { bubbles: true }));

    document.querySelectorAll('span[radio-elem]').forEach((item) => {
      item.classList.remove('actif');
    });
    var v = value.join('-');
    console.log(v);
    document.querySelectorAll('[radio-elem="' + v + '"]').forEach((item) => {
      item.classList.add('actif');
    })
  }

}

customElements.define('price-radios', PriceRadios);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
